module.exports = __webpack_public_path__ + "static/media/slider_porque_icon2.981b5cb0.svg";